<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Centri di Selezione',
      link: '/centri-selezione'
    }, {
      label: form.uuid ? 'Modifica Centro di Selezione' : 'Aggiungi nuova Centro di Selezione'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.displayName"
      :error-fields="errorFields"
      name="displayName"
      :submitted="submitted"
    >
      Nome
    </InputText>

    <InputText
      v-model="form.companyName"
      :error-fields="errorFields"
      name="companyName"
      :submitted="submitted"
    >
      Partecipante
    </InputText>

    <InputText
      v-model="form.address"
      :error-fields="errorFields"
      name="address"
      :submitted="submitted"
    >
      Indirizzo
    </InputText>

    <InputText
      v-model="form.phone"
      :error-fields="errorFields"
      name="phone"
      :submitted="submitted"
    >
      Telefono
    </InputText>

    <InputText
      v-model="form.fax"
      :error-fields="errorFields"
      name="fax"
      :submitted="submitted"
    >
      Fax
    </InputText>

    <InputText
      v-model="form.organizationCode"
      :error-fields="errorFields"
      name="organizationCode"
      :submitted="submitted"
    >
      Codice Organizzazione
    </InputText>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from "vue";

import InputInteger from "@/components/form/InputInteger.vue";
import InputText from "@/components/form/InputText.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const axios = useAxios();

let form = reactive({
  displayName: "",
  companyName: "",
  address: "",
  phone: "",
  fax: "",
  organizationCode: "",
  enabled: true
});

if (props.id) {
  const resp = await axios.get("/selection-site/" + props.id);
  form = reactive(resp.data);
}

const rules = {
  displayName: {
    type: "string",
    max: 64,
    required: true,
  },
  companyName: {
    type: "string",
    max: 64,
    required: true,
  },
  address: {
    type: "string",
    max: 128,
    required: true,
  },
  phone: {
    type: "string",
    max: 24
  },
  fax: {
    type: "string",
    max: 24
  },
  organizationCode: {
    type: "string",
    max: 24,
    required: true,
  },
};

const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'selection-site', rules, {
  create: 'Centro di Selezione creato con successo',
  update: 'Centro di Selezione modificato con successo'
}, '/centri-selezione', () => {
  form.displayName = "";
  form.companyName = "";
  form.address = "";
  form.phone = "";
  form.fax = "";
  form.organizationCode = "";
})

</script>
